/**
 * Hero Section Configuration
 *
 * To enable/disable different hero sections:
 * 1. Set enabled: true/false for each hero section
 * 2. Set activeHero to the hero section you want to display (1, 2, 3, 4, or 'original')
 *
 * Hero Section Types:
 * - 'original': The original gradient hero section
 * - 1: Gradient with floating elements and code mockup
 * - 2: Carousel with particle effects
 * - 3: Modern cards with grid background
 * - 4: Storefront with live featured products from the catalog
 */

export const heroConfig = {
  // Which hero section to display ('original', 1, 2, 3, or 4)
  activeHero: 4,

  // Individual hero section configurations
  heroSections: {
    original: {
      enabled: true,
      name: 'Original Hero',
      description: 'Simple gradient background with centered text',
    },
    hero1: {
      enabled: true,
      name: 'Gradient Float',
      description: 'Gradient background with floating elements and code mockup',
    },
    hero2: {
      enabled: true,
      name: 'Carousel Slider',
      description: 'Auto-sliding carousel with particle effects',
    },
    hero3: {
      enabled: true,
      name: 'Modern Cards',
      description: 'Modern design with floating project cards',
    },
    hero4: {
      enabled: true,
      name: 'Minimal Storefront',
      description:
        'Centered headline over a fan of live featured product covers',
    },
  },
};

// Helper function to get active hero component
export const getActiveHeroConfig = () => {
  const { activeHero, heroSections } = heroConfig;

  if (activeHero === 'original') {
    return heroSections.original.enabled ? 'original' : null;
  }

  const heroKey = `hero${activeHero}`;
  return heroSections[heroKey]?.enabled ? activeHero : null;
};

export default heroConfig;
